import { useMemo } from 'react';
import { useSize } from 'ahooks';

export const useDevice = () => {
  const htmlSize = useSize(() => document.querySelector('body'));

  const device = useMemo(() => {
    const width = htmlSize?.width;
    if (!width) {
      return '';
    }

    if (width > 1080) {
      return 'pc';
    }
    if (width <= 1080 && width >= 800) {
      return 'paid';
    }
    return 'mobile';
  }, [htmlSize]);
  return device;
};
